<template>
  <div>
    <div class="item" v-for="(item,i) in list" :key="i">
      <van-row>
        <van-col :span="12">付款单位</van-col>
        <van-col :span="12">{{item.company}}</van-col>
        <van-col :span="12">资金类别</van-col>
        <van-col :span="12">{{item.zijinzl}}</van-col>
        <van-col :span="12">资金子类</van-col>
        <van-col :span="12">{{item.zijinzl}}</van-col>
        <van-col :span="12">发票凭证号</van-col>
        <van-col :span="12">{{item.fapiao}}</van-col>
        <van-col :span="12">收入类型</van-col>
        <van-col :span="12">{{item.shourulx}}</van-col>
        <van-col :span="12">描述</van-col>
        <van-col :span="12">{{item.miaoshu}}</van-col>
        <van-col :span="12">收入子类</van-col>
        <van-col :span="12">{{item.shouruzl}}</van-col>
        <van-col :span="12">收入确认日期</van-col>
        <van-col :span="12">{{item.shouruqrrq}}</van-col>
        <van-col :span="12">收入金额</van-col>
        <van-col :span="12">{{item.shouruje}}</van-col>
        <van-col :span="12">未销金额</van-col>
        <van-col :span="12">{{item.weixiaoje}}</van-col>
      </van-row>
      <div class="text-right">
        <van-button size="small" type="primary">已选</van-button>
      </div>
    </div>
    <div class="mt10">
      <van-button block type="primary">提交</van-button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [{
          company: '付款单位',
          zijinlb: '资金类别',
          zijinzl: '资金子类',
          fapiao: '发票凭证号',
          shourulx: '收入类型',
          miaoshu: '描述',
          shouruzl: '收入子类',
          shouruqrrq: '收入确认日期',
          shouruje: '收入金额',
          weixiaoje: '未销金额',
        }, {
          company: '付款单位',
          zijinlb: '资金类别',
          zijinzl: '资金子类',
          fapiao: '发票凭证号',
          shourulx: '收入类型',
          miaoshu: '描述',
          shouruzl: '收入子类',
          shouruqrrq: '收入确认日期',
          shouruje: '收入金额',
          weixiaoje: '未销金额',
        }]
      }
    },
  }
</script>

<style lang="less" scoped>
  .item {
    background: white;
    margin-top: 1rem;
    padding: 1rem;
  }
</style>
